import React, { useEffect, useRef, useState } from 'react'
import { RouterProps, useNavigate, Link, useLocation } from 'react-router-dom'
import logo from '../logo.svg'
import './NoteModal.scss'
import { Helmet } from 'react-helmet-async'
import SideMenu from '../components/SideMenu'
import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  notesSlice,
  methods,
  userSlice,
  configSlice,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { bindEvent } from '../modules/bindEvent'
import { useTranslation } from 'react-i18next'
import { snackbar, prompt, alert, multiplePrompts } from '@saki-ui/core'

import { Header } from '../components'
import { api } from '../modules/electron/api'
import { NoteItem } from '../store/notes/typings'
import { ReaderRouterProps } from '../modules/renderRoutes'
import { SyncOff } from './Icon'
import {
  SakiAsideModal,
  SakiAvatar,
  SakiBreadcrumb,
  SakiButton,
  SakiCheckbox,
  SakiCheckboxItem,
  SakiDropdown,
  SakiIcon,
  SakiInput,
  SakiMenuItem,
  SakiModal,
  SakiModalHeader,
  SakiRow,
  SakiTitle,
} from './saki-ui-react/components'
import { httpApi } from '../modules/http/api'
import { copyText, Query, readClipboardText } from '../modules/methods'
import { Debounce } from '@nyanyajs/utils'
import {
  getNoteByCloud,
  getNoteMergeOrReplaceAlert,
  getNotePermissions,
} from '../store/notes/methods'

const NoteModalComponent = () => {
  return (
    <div className="note-modal-component">
      <ShareNoteModal />
      <NotePermissionsModal />
      <CloudNoteModal />
    </div>
  )
}

const ShareNoteModal = () => {
  const { t, i18n } = useTranslation('indexPage')

  const d = useRef(new Debounce())
  const dispatch = useDispatch<AppDispatch>()

  const notes = useSelector((state: RootState) => state.notes)
  const user = useSelector((state: RootState) => state.user)
  const config = useSelector((state: RootState) => state.config)

  const shareNoteModal = useSelector(
    (state: RootState) => state.config.pageConfig.shareNoteModal
  )

  let history = useNavigate()

  const [permission, setPermission] = useState(5)

  const [showPermissionsDP, setShowPermissionsDP] = useState(false)
  const [shareUrl, setShareUrl] = useState('')

  const permissionsTemplate: typeof notes.permissionsTemplate =
    notes.permissionsTemplate.map((v) => {
      return {
        ...v,
        text: t(v.text, {
          ns: 'indexPage',
        }),
      }
    })

  useEffect(() => {
    if (shareNoteModal.visible) {
    }
    return () => {
      setShareUrl('')
      setShowPermissionsDP(false)
    }
  }, [shareNoteModal.visible])

  const getShareUrl = async () => {
    console.log(permission)
    const res = await httpApi.v1.getInvitationCode({
      noteId: shareNoteModal.noteId,
      permission,
    })
    console.log('getShareUrl', res)
    if (res.code === 200 && res.data.invitationCode) {
      const url = Query(window.location.origin, {
        nid: shareNoteModal.noteId,
        ic: res.data.invitationCode,
      })
      console.log('location', url)
      setShareUrl(url)

      copyText(url)
      return
    }
    snackbar({
      message: res.error || res.msg,
      vertical: 'top',
      horizontal: 'center',
      autoHideDuration: 2000,
      closeIcon: true,
    }).open()
  }

  return (
    <SakiAsideModal
      ref={
        bindEvent({
          close() {
            dispatch(
              configSlice.actions.setShareNoteModal({
                visible: false,
                noteId: '',
              })
            )
          },
        }) as any
      }
      visible={shareNoteModal.visible}
      vertical={config.deviceType === 'Mobile' ? 'Bottom' : 'Center'}
      horizontal="Center"
      width="100%"
      // height='100%'
      max-width={config.deviceType === 'Mobile' ? 'auto' : '420px'}
      // max-height={config.deviceType === 'Mobile' ? '100%' : '600px'}
      border-radius={config.deviceType === 'Mobile' ? '10px 10px 0 0' : '10px'}
      mask
      maskBackgroundColor={
        config.deviceType === 'Mobile' ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0)'
      }
      mask-closable
      backgroundColor="#fff"
    >
      <SakiModalHeader
        border
        close-icon
        ref={
          bindEvent({
            close() {
              dispatch(
                configSlice.actions.setShareNoteModal({
                  visible: false,
                  noteId: '',
                })
              )
            },
          }) as any
        }
        title={t('shareNote')}
      >
        <div
          style={{
            margin: '0 10px 0 0',
          }}
          slot="right"
        >
          <SakiButton
            onTap={() => {
              dispatch(
                configSlice.actions.setShareNoteModal({
                  visible: false,
                  noteId: '',
                })
              )
              dispatch(
                configSlice.actions.setNotePermissionsModal({
                  visible: true,
                  noteId: shareNoteModal.noteId || '',
                })
              )
            }}
            border="none"
            type="Normal"
          >
            <span>{t('notePermissions')}</span>
          </SakiButton>
        </div>
      </SakiModalHeader>
      <div className="share-note-modal">
        {shareUrl ? (
          <SakiInput
            type="Textarea"
            border="1px solid #eee"
            fontSize="14px"
            padding="10px"
            minHeight="100px"
            margin="0 0 10px 0"
            borderRadius="10px"
            value={shareUrl}
          />
        ) : (
          ''
        )}
        {shareUrl ? (
          <span className="sn-tip">
            {t('validTime', {
              ns: 'indexPage',
            })}
          </span>
        ) : (
          ''
        )}
        <div className="sn-permissions">
          <SakiDropdown
            visible={showPermissionsDP}
            floatingDirection="Center"
            ref={
              bindEvent({
                close: () => {
                  setShowPermissionsDP(false)
                },
              }) as any
            }
          >
            <saki-button
              ref={bindEvent({
                tap: () => {
                  setShowPermissionsDP(true)
                },
              })}
              margin="0"
              padding="6px 8px"
              border="none"
            >
              <SakiRow alignItems="center">
                <span>
                  {permissionsTemplate.filter((v) => v.val === permission)?.[0]
                    ?.text ||
                    t('permissions', {
                      ns: 'indexPage',
                    })}
                </span>
                <SakiIcon
                  color="#999"
                  width="12px"
                  height="12px"
                  margin="0 0 0 4px"
                  type="Bottom"
                ></SakiIcon>
              </SakiRow>
            </saki-button>

            <div slot="main">
              <saki-menu
                ref={bindEvent({
                  selectvalue: (e) => {
                    setPermission(Number(e.detail.value))
                    setShowPermissionsDP(false)
                  },
                })}
              >
                {permissionsTemplate.map((v, i) => {
                  return (
                    <saki-menu-item font-size="14px" value={v.val} key={i}>
                      {v.text}
                    </saki-menu-item>
                  )
                })}
              </saki-menu>
            </div>
          </SakiDropdown>
          <SakiButton
            onTap={() => {
              if (shareUrl) {
                copyText(shareUrl)
                return
              }
              getShareUrl()
            }}
            padding="6px 8px"
            type="Primary"
          >
            <span>
              {shareUrl
                ? t('copy', {
                    ns: 'sakiuiPrompt',
                  })
                : t('share', {
                    ns: 'sakiuiPrompt',
                  })}
            </span>
          </SakiButton>
        </div>
      </div>
    </SakiAsideModal>
  )
}

const NotePermissionsModal = () => {
  const { t, i18n } = useTranslation('indexPage')

  const d = useRef(new Debounce())
  const dispatch = useDispatch<AppDispatch>()

  const notes = useSelector((state: RootState) => state.notes)
  const user = useSelector((state: RootState) => state.user)
  const config = useSelector((state: RootState) => state.config)

  const notePermissionsModal = useSelector(
    (state: RootState) => state.config.pageConfig.notePermissionsModal
  )

  let history = useNavigate()

  const [showPermissionsDPId, setShowPermissionsDPId] = useState('')
  const [shareUrl, setShareUrl] = useState('')

  const permissionsTemplate: typeof notes.permissionsTemplate =
    notes.permissionsTemplate
      .map((v) => {
        return {
          ...v,
          text: t(v.text, {
            ns: 'indexPage',
          }),
        }
      })
      .concat({
        text: t('delete', {
          ns: 'sakiuiPrompt',
        }),
        val: -1,
      })

  useEffect(() => {
    if (notePermissionsModal.visible) {
      getNotePermissions(notePermissionsModal.noteId || '')
    }
    return () => {
      setShareUrl('')
      setShowPermissionsDPId('')
    }
  }, [notePermissionsModal.visible])

  const updateNotPermissions = async (userId: string, permission: number) => {
    const npRes = await httpApi.v1.UpdateNotePermissions({
      noteId: notePermissionsModal.noteId || '',
      userId,
      permission,
    })
    console.log('getPermissions', npRes)
    if (npRes.code === 200) {
      let obj = {
        ...notes.permissions,
      }
      if (permission === -1) {
        obj[notePermissionsModal.noteId || ''] = obj[
          notePermissionsModal.noteId || ''
        ].filter((v) => v.authorId !== userId)
      } else {
        obj[notePermissionsModal.noteId || ''].forEach((v) => {
          if (v.authorId === userId) {
            v.permission = permission
          }
        })
      }

      dispatch(notesSlice.actions.setPermissions(obj))
    }
  }

  return (
    <SakiAsideModal
      ref={
        bindEvent({
          close() {
            dispatch(
              configSlice.actions.setNotePermissionsModal({
                visible: false,
                noteId: '',
              })
            )
          },
        }) as any
      }
      visible={notePermissionsModal.visible}
      vertical={config.deviceType === 'Mobile' ? 'Bottom' : 'Center'}
      horizontal="Center"
      width="100%"
      // height='100%'
      max-width={config.deviceType === 'Mobile' ? 'auto' : '420px'}
      // max-height={config.deviceType === 'Mobile' ? '100%' : '600px'}
      border-radius={config.deviceType === 'Mobile' ? '10px 10px 0 0' : '10px'}
      mask
      maskBackgroundColor={
        config.deviceType === 'Mobile' ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0)'
      }
      mask-closable
      backgroundColor="#fff"
    >
      <SakiModalHeader
        border
        close-icon
        ref={
          bindEvent({
            close() {
              dispatch(
                configSlice.actions.setNotePermissionsModal({
                  visible: false,
                  noteId: '',
                })
              )
            },
          }) as any
        }
        title={t('notePermissions')}
      >
        <div
          style={{
            margin: '0 10px 0 0',
          }}
          slot="right"
        >
          <SakiButton
            onTap={() => {
              dispatch(
                configSlice.actions.setNotePermissionsModal({
                  visible: false,
                  noteId: '',
                })
              )
              dispatch(
                configSlice.actions.setShareNoteModal({
                  visible: true,
                  noteId: notePermissionsModal.noteId || '',
                })
              )
            }}
            border="none"
            type="Normal"
          >
            <span>
              {t('share', {
                ns: 'sakiuiPrompt',
              })}
            </span>
          </SakiButton>
        </div>
      </SakiModalHeader>
      <div className="note-permissions-modal">
        <div className="np-users">
          <SakiTitle margin="0 0 10px 0" level={4}>
            {t('collaborators', {
              ns: 'indexPage',
            })}
          </SakiTitle>
          <div className="s-u-list">
            {notes.permissions[notePermissionsModal?.noteId]?.map((v, i) => {
              return (
                <div key={i} className="s-u-l-item">
                  <div className="item-left">
                    <SakiAvatar
                      width="28px"
                      height="28px"
                      borderRadius="50%"
                      src={v?.userInfo?.avatar || ''}
                      nickname={v?.userInfo?.nickname || ''}
                      margin="0 6px 0 0"
                    ></SakiAvatar>
                    <span>{v?.userInfo?.nickname || ''}</span>
                  </div>
                  <div className="item-right">
                    {v.ownerId === v.authorId ||
                    v.ownerId !== user.userInfo.uid ? (
                      <span>
                        {v.permission === 100
                          ? t('owner', {
                              ns: 'indexPage',
                            })
                          : v.permission === 5
                            ? t('editable', {
                                ns: 'indexPage',
                              })
                            : t('onlyView', {
                                ns: 'indexPage',
                              })}
                      </span>
                    ) : (
                      <SakiDropdown
                        visible={showPermissionsDPId === v.authorId}
                        floatingDirection="Center"
                        ref={
                          bindEvent({
                            close: () => {
                              setShowPermissionsDPId('')
                            },
                          }) as any
                        }
                      >
                        <saki-button
                          ref={bindEvent({
                            tap: () => {
                              setShowPermissionsDPId(v.authorId || '')
                            },
                          })}
                          margin="0"
                          padding="6px 8px"
                          border="none"
                        >
                          <SakiRow alignItems="center">
                            <span>
                              {v.permission === 100
                                ? t('owner', {
                                    ns: 'indexPage',
                                  })
                                : v.permission === 5
                                  ? t('editable', {
                                      ns: 'indexPage',
                                    })
                                  : t('onlyView', {
                                      ns: 'indexPage',
                                    })}
                            </span>
                            <SakiIcon
                              color="#999"
                              width="12px"
                              height="12px"
                              margin="0 0 0 4px"
                              type="Bottom"
                            ></SakiIcon>
                          </SakiRow>
                        </saki-button>

                        <div slot="main">
                          <saki-menu
                            ref={bindEvent({
                              selectvalue: (e) => {
                                updateNotPermissions(
                                  v.authorId || '',
                                  Number(e.detail.value)
                                )
                                setShowPermissionsDPId('')
                              },
                            })}
                          >
                            {permissionsTemplate.map((sv, i) => {
                              return (
                                <SakiMenuItem
                                  font-size="14px"
                                  value={String(sv.val)}
                                  active={sv.val === v.permission}
                                  key={i}
                                >
                                  {sv.text}
                                </SakiMenuItem>
                              )
                            })}
                          </saki-menu>
                        </div>
                      </SakiDropdown>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </SakiAsideModal>
  )
}

const CloudNoteModal = () => {
  const { t, i18n } = useTranslation('indexPage')

  const d = useRef(new Debounce())
  const dispatch = useDispatch<AppDispatch>()

  const notes = useSelector((state: RootState) => state.notes)
  const user = useSelector((state: RootState) => state.user)
  const config = useSelector((state: RootState) => state.config)

  const cloudNoteModal = useSelector(
    (state: RootState) => state.config.pageConfig.cloudNoteModal
  )

  let history = useNavigate()

  const [permission, setPermission] = useState(5)

  const [shareUrl, setShareUrl] = useState('')

  const permissions: typeof notes.permissionsTemplate =
    notes.permissionsTemplate.map((v) => {
      return {
        ...v,
        text: t(v.text, {
          ns: 'indexPage',
        }),
      }
    })

  useEffect(() => {
    if (cloudNoteModal.visible) {
      readClipboardText().then((val) => {
        setShareUrl(val?.trim() || '')
        console.log('readClipboardText', val)
      })
    }
    return () => {
      setShareUrl('')
    }
  }, [cloudNoteModal.visible])

  const agreeAndDownloadNote = async () => {
    let ic =
      shareUrl
        .split('&')
        ?.map((v) => {
          return v.split('=')
        })
        .filter((v) => v?.[0] === 'ic')
        .map((v) => {
          return v?.[1]
        })?.[0] || shareUrl

    const res = await httpApi.v1.AgreeAndDownloadNote({
      invitationCode: ic,
    })
    console.log('agreeAndDownloadNote', res, shareUrl, ic)

    if (res.code === 200) {
      getNoteMergeOrReplaceAlert(res.data?.noteId || '')
      dispatch(
        configSlice.actions.setCloudNoteModal({
          visible: false,
        })
      )
    } else {
      snackbar({
        message: [res.cnMsg, res.msg, res.error].filter((v) => v).join('; '),
        vertical: 'top',
        horizontal: 'center',
        autoHideDuration: 2000,
        closeIcon: true,
      }).open()
    }
  }

  return (
    <SakiAsideModal
      ref={
        bindEvent({
          close() {
            dispatch(
              configSlice.actions.setCloudNoteModal({
                visible: false,
              })
            )
          },
        }) as any
      }
      visible={cloudNoteModal.visible}
      vertical={config.deviceType === 'Mobile' ? 'Bottom' : 'Center'}
      horizontal="Center"
      width="100%"
      // height='100%'
      max-width={config.deviceType === 'Mobile' ? 'auto' : '420px'}
      // max-height={config.deviceType === 'Mobile' ? '100%' : '600px'}
      border-radius={config.deviceType === 'Mobile' ? '10px 10px 0 0' : '10px'}
      mask
      maskBackgroundColor={
        config.deviceType === 'Mobile' ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0)'
      }
      mask-closable
      backgroundColor="#fff"
    >
      <SakiModalHeader
        border
        close-icon
        ref={
          bindEvent({
            close() {
              dispatch(
                configSlice.actions.setCloudNoteModal({
                  visible: false,
                })
              )
            },
          }) as any
        }
        title={t('noteInvitationCode')}
      ></SakiModalHeader>

      <div className="cloud-note-modal">
        <SakiInput
          onChangevalue={(e) => {
            setShareUrl(e.detail || '')
          }}
          type="Textarea"
          border="1px solid #eee"
          fontSize="14px"
          padding="10px"
          minHeight="100px"
          margin="0 0 10px 0"
          borderRadius="10px"
          value={shareUrl}
        />
        <div className="sn-permissions">
          <div></div>
          <SakiButton
            onTap={() => {
              agreeAndDownloadNote()
            }}
            padding="6px 8px"
            type="Primary"
          >
            <span>
              {t('agreeAndDownloadNote', {
                ns: 'indexPage',
              })}
            </span>
          </SakiButton>
        </div>
      </div>
    </SakiAsideModal>
  )
}

export default NoteModalComponent
